/**
 * Import deps.
 */
import Alpine from 'alpinejs';

/**
 * Import modules.
 */
import registerForm from './modules/register-form/register-form';
import Select2 from './modules/select2/select2';
import GameWorldSelection from './modules/game-world-selection/game-world-selection';

/**
 * Initialize.
 */
window.Alpine = Alpine;
Alpine.data('registerForm', registerForm);
Alpine.start();

new Select2();
new GameWorldSelection();